import request from '../config/request';

export const FoodicsSignInAPI = async (body: any) => {
  const response = await request({
    url: `/app/provider/foodics/signin`,
    body: body,
    method: 'POST',
    customURl: true,
  });

  return response;
};

export const FoodicsOtpVerificationAPI = async (body: any) => {
  const response = await request({
    url: `/app/provider/foodics/otp-verification`,
    body: body,
    method: 'POST',
    customURl: true,
  });

  return response;
};

export const FoodicsResendOTP = async (body: any) => {
  const response = await request({
    url: `/app/provider/foodics/otp-verification`,
    body: body,
    method: 'POST',
    customURl: true,
  });

  return response;
};

// Called after Foodics redirects back with code and state
export const FoodicsAuthorizeCallbackAPI = async (params: { code: string; state: string }) => {
  const { code, state } = params;
  const response = await request({
    url: `/app/provider/foodics/auth`,
    method: 'POST',
    body: { code, state },
    customURl: true,
  });

  return response;
};

// Trigger server-side import after successful authorization
export const FoodicsStartImportAPI = async (params: {
  providerId: string;
  priceWithVat: boolean;
}) => {
  const response = await request({
    url: `/app/provider/foodics/import`,
    method: 'POST',
    body:params,
    customURl: true,
  });

  return response;
};
